import { render } from "./AdminEmployee.vue?vue&type=template&id=68d4e016&scoped=true"
import script from "./AdminEmployee.vue?vue&type=script&lang=js"
export * from "./AdminEmployee.vue?vue&type=script&lang=js"

import "./AdminEmployee.vue?vue&type=style&index=0&id=68d4e016&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d4e016"]])

export default __exports__